<script lang="ts">
    import {onMount} from "svelte";
import { mapZoom } from "../helpers/consts";
    import {createMap, createMarker} from "../helpers/map";
    import type {ServiceType} from "../store/types";

    export let zoomMap = mapZoom;
    export let height = '500px';
    export let services:ServiceType[];
    export let moveToCenter:boolean = false;
    let isMounted = false;

    $:{
        if(isMounted) init_map(services);
    }

    onMount(() => {
        init_map(services);
        isMounted = true;
    });

    const init_map = (services:ServiceType[]) => {
        createMap('map', zoomMap);

        services.map((service, index) => {
            createMarker(service, (index === services.length - 1 ? true : false));
        });
    }

</script>

<div id="map" style={'height:' + height}>
    <h1>Map</h1>
</div>

<style>
    #map {
        background-color: teal;
        width: 100%;
        line-height: 500px;
        text-align: center;
        color: white;
        z-index: 0 !important;
    }
</style>